import { ChainId } from '@1inch-community/models';
const isSupportFusionList = [
    ChainId.eth,
    ChainId.bnb,
    ChainId.matic,
    ChainId.arbitrum,
    ChainId.avalanche,
    ChainId.op,
    ChainId.gnosis,
    ChainId.fantom,
];
export function isSupportFusion(chainId) {
    return isSupportFusionList.includes(chainId);
}
//# sourceMappingURL=is-support-fusion.js.map